<template>
  <div class="personnel-notify-container">
    <!-- Main Data Table Card -->
    <v-card class="elevation-8 rounded-lg">
      <v-card-title class="primary white--text">
        <v-icon left color="white" size="28">mdi-clipboard-text</v-icon>
        <span class="">ข้อมูลแจ้งปรับปรุงข้อมูลจากสถานศึกษา</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="white"
          @click="refreshData"
          :loading="loading"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      

      <v-card-text class="pa-0">
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="personnel_temporary_notifys"
          :search="search"
          :items-per-page="15"
          :footer-props="{
            'items-per-page-options': [10, 15, 25, 50, -1],
            'items-per-page-text': 'รายการต่อหน้า:'
          }"
          loading-text="กำลังโหลดข้อมูล..."
          no-data-text="ไม่มีข้อมูล"
          class="enhanced-table"
        >
        <template v-slot:top>
          <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหาข้อมูล (ชื่อ, รหัสบัตร, วิทยาลัย)"
          single-line
          hide-details
          dense
          filled
          rounded
          class="search-field"
          clearable
        />
        </template>
          <!-- Status Chip -->
          <template v-slot:item.personnel_temporary_notifyStatus="{ item }">
            <v-chip
              :color="getStatusColor(item.personnel_temporary_notifyStatus)"
              :text-color="getStatusTextColor(item.personnel_temporary_notifyStatus)"
              small
              label
            >
              <v-icon left small>{{ getStatusIcon(item.personnel_temporary_notifyStatus) }}</v-icon>
              {{ getStatusText(item.personnel_temporary_notifyStatus) }}
            </v-chip>
          </template>

          <!-- Action Buttons -->
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="personnel_temporaryEdit(item.id_card, item.personnel_temporary_notifyID)"
                  color="warning"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>แก้ไขข้อมูล</span>
            </v-tooltip>
          </template>

          <template v-slot:item.actionDel="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.personnel_temporary_notifyStatus === 'send'"
                  @click="personnel_temporaryUPdate(item.personnel_temporary_notifyID)"
                  color="success"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-check-circle</v-icon>
                </v-btn>
              </template>
              <span>ทำเครื่องหมายเสร็จสิ้น</span>
            </v-tooltip>
          </template>

          <!-- No Results -->
          <template v-slot:no-results>
            <v-alert
              :value="true"
              color="info"
              icon="mdi-information"
              class="ma-4"
            >
              ไม่พบผลลัพธ์สำหรับ "{{ search }}"
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Edit Dialog -->
    <v-dialog
      v-model="editpersonnel_temporarydialog"
      persistent
      max-width="1200px"
      scrollable
    >
      <v-card class="edit-dialog">
        <v-card-title class="warning white--text">
          <v-icon left color="white">mdi-account-edit</v-icon>
          <span class="text-h5">แก้ไขข้อมูลบุคลากร</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="white"
            @click="editpersonnel_temporarydialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <v-form ref="editpersonnel_temporaryform" lazy-validation>
            <!-- Section 1: Basic Info -->
            <v-expansion-panels v-model="activePanel" multiple accordion>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <v-icon left color="primary">mdi-account-group</v-icon>
                    <span class="text-h6">1. ประเภทบุคคล/สังกัด</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="editpersonnel_temporary.user_status"
                        :items="userstatus"
                        item-text="user_status_name"
                        item-value="user_status_sub"
                        label="ประเภทบุคลากร"
                        :rules="requiredRules"
                        prepend-icon="mdi-account-cog"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.college_code"
                        :items="colleges"
                        item-text="college_name"
                        item-value="college_code"
                        label="วิทยาลัย"
                        @change="man_powerQuery()"
                        :rules="requiredRules"
                        prepend-icon="mdi-school"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Section 2: Personal Info -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <v-icon left color="success">mdi-account</v-icon>
                    <span class="text-h6">2. ข้อมูลส่วนบุคคล</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editpersonnel_temporary.id_card"
                        label="รหัสบัตรประชาชน"
                        :rules="idCardRules"
                        prepend-icon="mdi-card-account-details"
                        outlined
                        dense
                        maxlength="13"
                        @input="validateInput()"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.title_s"
                        :items="prefixs"
                        item-text="prefix_name"
                        item-value="prefix_name"
                        label="คำนำหน้า"
                        prepend-icon="mdi-account"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editpersonnel_temporary.frist_name"
                        label="ชื่อ"
                        prepend-icon="mdi-account"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editpersonnel_temporary.last_name"
                        label="นามสกุล"
                        prepend-icon="mdi-account"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>

                  <!-- Birth Date -->
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editpersonnel_temporary.brith_day"
                        :items="days"
                        label="วันเกิด"
                        prepend-icon="mdi-calendar"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editpersonnel_temporary.brith_month"
                        :items="months"
                        label="เดือนเกิด"
                        prepend-icon="mdi-calendar"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.brith_year"
                        :items="years"
                        label="ปีเกิด"
                        prepend-icon="mdi-calendar"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>

                  <!-- Contact Info -->
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="editpersonnel_temporary.tel_p"
                        label="เบอร์โทรศัพท์"
                        prepend-icon="mdi-phone"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="editpersonnel_temporary.e_mail"
                        label="อีเมล"
                        prepend-icon="mdi-email"
                        outlined
                        dense
                        type="email"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Section 3: Position -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <v-icon left color="info">mdi-briefcase</v-icon>
                    <span class="text-h6">3. ข้อมูลตำแหน่ง</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.position_name"
                        :items="userstatus"
                        item-text="user_status_name"
                        item-value="user_status_name"
                        label="ตำแหน่ง"
                        prepend-icon="mdi-account-tie"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.id_position"
                        :items="man_powers"
                        item-text="id_position"
                        item-value="id_position"
                        label="เลขที่ตำแหน่ง"
                        prepend-icon="mdi-numeric"
                        outlined
                        dense
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">
                              {{ item.id_position }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.positions }} : {{ item.id_card }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.rang_name"
                        :items="rang_names"
                        item-text="text"
                        item-value="value"
                        label="วิทยฐานะ"
                        :rules="requiredRules"
                        prepend-icon="mdi-school"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editpersonnel_temporary.rang_level"
                        :items="rang_levels"
                        item-text="text"
                        item-value="value"
                        label="ระดับ"
                        prepend-icon="mdi-format-list-numbered"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Section 4: Education -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <v-icon left color="warning">mdi-school</v-icon>
                    <span class="text-h6">4. วุฒิการศึกษา</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="editpersonnel_temporary.ed_abb"
                        label="วุฒิการศึกษา"
                        prepend-icon="mdi-certificate"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="editpersonnel_temporary.ed_name"
                        label="สาขาวิชา"
                        prepend-icon="mdi-book-open"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Section 5: Appointment -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <v-icon left color="error">mdi-clipboard-check</v-icon>
                    <span class="text-h6">5. ข้อมูลการบรรจุ</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.type_personnel"
                        :items="type_personnelApp"
                        item-text="text"
                        item-value="value"
                        label="ประเภทการบรรจุ"
                        prepend-icon="mdi-account-plus"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="editpersonnel_temporary.rang_condition"
                        value="1"
                        label="กลุ่ม จชต. ชายแดนภาคใต้"
                        class="mt-0"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editpersonnel_temporary.order_app_now"
                        label="คำสั่งที่บรรจุ"
                        prepend-icon="mdi-file-document"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>

                  <!-- Appointment Date -->
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editpersonnel_temporary.appoin_day"
                        :items="days"
                        label="วันที่บรรจุ"
                        prepend-icon="mdi-calendar-check"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editpersonnel_temporary.appoin_month"
                        :items="months"
                        label="เดือนที่บรรจุ"
                        prepend-icon="mdi-calendar-check"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="editpersonnel_temporary.appoin_year"
                        :items="years"
                        label="ปีที่บรรจุ"
                        prepend-icon="mdi-calendar-check"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Section 6: Current Work -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <v-icon left color="purple">mdi-calendar-clock</v-icon>
                    <span class="text-h6">6. การปฏิบัติงาน ณ ปัจจุบัน</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-menu
                        ref="menu5"
                        v-model="menu5"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editpersonnel_temporary.date_app_now"
                            label="วันเริ่มปฏิบัติงาน ณ สถานศึกษาปัจจุบัน"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="editpersonnel_temporary.date_app_now"
                          no-title
                          scrollable
                          locale="th"
                          @input="menu5 = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-menu
                        ref="menu6"
                        v-model="menu6"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editpersonnel_temporary.date_app_positonnow"
                            label="วันเริ่มปฏิบัติงาน ในตำแหน่งปัจจุบัน"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="editpersonnel_temporary.date_app_positonnow"
                          no-title
                          scrollable
                          locale="th"
                          @input="menu6 = false"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn
            large
            outlined
            @click="editpersonnel_temporarydialog = false"
            class="mr-2"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="warning"
            @click="editpersonnel_temporarySubmit()"
            :loading="saving"
          >
            <v-icon left>mdi-content-save</v-icon>
            บันทึกข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notification -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import VueMoment from "vue-moment";
import moment from "moment-timezone";

export default {
  name: "personnel_temporary_notify",
  
  data() {
    return {
      VueMoment,
      moment,
      loading: false,
      saving: false,
      ApiKey: "HRvec2021",
      activePanel: [0], // Open first panel by default
      
      // Snackbar
      snackbar: {
        show: false,
        color: "success",
        timeout: 5000,
        icon: "mdi-check",
        text: ""
      },

      // Data
      personnel_temporary_notifys: [],
      search: "",
      editpersonnel_temporary: {},
      editpersonnel_temporarydialog: false,
      updatepersonnel_temporary_notify: {},
      
      // Options
      userstatus: [],
      colleges: [],
      man_powers: [],
      prefixs: [],
      
      // Form validation
      validateInputcheck: "true",
      requiredRules: [v => !!v || 'กรุณากรอกข้อมูลนี้'],
      idCardRules: [
        v => !!v || 'กรุณากรอกรหัสบัตรประชาชน',
        v => (v && v.length === 13) || 'รหัสบัตรประชาชนต้องมี 13 หลัก',
        () => this.validateInputcheck === 'true' || 'รหัสบัตรประชาชนไม่ถูกต้อง'
      ],

      // Table headers
      headers: [
        { text: "วิทยาลัย", align: "left", value: "college_name", width: "200" },
        { text: "รหัสบัตร", align: "center", value: "id_card", width: "130" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "frist_names", width: "180" },
        { text: "รายละเอียด", align: "left", value: "personnel_temporary_notifyDetail", width: "250" },
        { text: "สถานะ", align: "center", value: "personnel_temporary_notifyStatus", width: "120" },
        { text: "วันที่ร้องขอ", align: "center", value: "personnel_temporary_notifyDateTIme", width: "130" },
        { text: "แก้ไข", align: "center", value: "actions", sortable: false, width: "80" },
        { text: "เสร็จสิ้น", align: "center", value: "actionDel", sortable: false, width: "80" }
      ],

      // Date/Time options
      menu5: false,
      menu6: false,
      date: new Date().toISOString().substr(0, 10),

      // Dropdown options
      type_personnelApp: [
        { text: "ครูพัฒนาท้องถิ่น", value: "local_dev" },
        { text: "ครูโอนย้าย", value: "transfer_position" },
        { text: "คัดเลือก(ภายใน)", value: "select" },
        { text: "แข่งขัน(ภายนอก)", value: "recruit" }
      ],
      
      rang_names: [
        { text: "ต้น", value: "ต้น" },
        { text: "ปฏิบัติงาน", value: "ปฏิบัติงาน" },
        { text: "ปฏิบัติการ", value: "ปฏิบัติการ" },
        { text: "ชำนาญงาน", value: "ชำนาญงาน" },
        { text: "ชำนาญการ", value: "ชำนาญการ" },
        { text: "ชำนาญการพิเศษ", value: "ชำนาญการพิเศษ" },
        { text: "เชี่ยวชาญ", value: "เชี่ยวชาญ" },
        { text: "เชี่ยวชาญพิเศษ", value: "เชี่ยวชาญพิเศษ" }
      ],
      
      rang_levels: [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" }
      ],

      days: Array.from({ length: 31 }, (_, i) => ({ 
        text: (i + 1).toString(), 
        value: (i + 1).toString() 
      })),
      
      months: [
        { text: "มกราคม", value: "1" },
        { text: "กุมภาพันธ์", value: "2" },
        { text: "มีนาคม", value: "3" },
        { text: "เมษายน", value: "4" },
        { text: "พฤษภาคม", value: "5" },
        { text: "มิถุนายน", value: "6" },
        { text: "กรกฎาคม", value: "7" },
        { text: "สิงหาคม", value: "8" },
        { text: "กันยายน", value: "9" },
        { text: "ตุลาคม", value: "10" },
        { text: "พฤศจิกายน", value: "11" },
        { text: "ธันวาคม", value: "12" }
      ],
      
      years: Array.from({ length: 60 }, (_, i) => ({ 
        text: (2500 + i).toString(), 
        value: (2500 + i).toString() 
      }))
    };
  },

  async mounted() {
    await this.initializeData();
  },

  methods: {
    async initializeData() {
      this.loading = true;
      try {
        await Promise.all([
          this.personnel_temporary_notifyQueryAll(),
          this.loadUserStatus(),
          this.loadColleges(),
          this.loadPrefixes()
        ]);
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการโหลดข้อมูล', 'error');
      } finally {
        this.loading = false;
      }
    },

    async loadUserStatus() {
      const result = await this.$http.post("user_status.php", { ApiKey: this.ApiKey });
      this.userstatus = result.data;
    },

    async loadColleges() {
      const result = await this.$http.post("college.php", { ApiKey: this.ApiKey });
      this.colleges = result.data;
    },

    async loadPrefixes() {
      const result = await this.$http.post("prefix.php", { ApiKey: this.ApiKey });
      this.prefixs = result.data;
    },

    async man_powerQuery() {
      if (!this.editpersonnel_temporary.college_code) return;
      
      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          j18college_code: this.editpersonnel_temporary.college_code
        });
        this.man_powers = result.data;
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการโหลดข้อมูลตำแหน่ง', 'error');
      }
    },

    async personnel_temporaryEdit(id_card, personnel_temporary_notifyID) {
      try {
        const result = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: id_card
        });
        
        this.editpersonnel_temporary = { ...result.data };
        this.editpersonnel_temporary.p_word = "";
        this.editpersonnel_temporary.personnel_temporary_notifyID = personnel_temporary_notifyID;
        
        await this.man_powerQuery();
        this.validateInput();
        this.editpersonnel_temporarydialog = true;
        this.activePanel = [0, 1]; // Open first two panels
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการโหลดข้อมูลบุคลากร', 'error');
      }
    },

    async editpersonnel_temporarySubmit() {
      if (!this.$refs.editpersonnel_temporaryform.validate()) {
        this.showSnackbar('กรุณากรอกข้อมูลให้ครบถ้วน', 'warning');
        return;
      }

      this.saving = true;
      try {
        // Prepare data
        const submitData = { ...this.editpersonnel_temporary };
        submitData.ApiKey = this.ApiKey;
        
        if (submitData.p_word === "") {
          delete submitData.p_word;
        }
        
        if (submitData.rang_condition == null) {
          submitData.rang_condition = "0";
        }

        // Update personnel data
        const result = await this.$http.post(
          "personnel_temporary.update.admin.php",
          submitData
        );

        // Update notification status
        const notifyData = {
          ApiKey: this.ApiKey,
          personnel_temporary_notifyID: submitData.personnel_temporary_notifyID,
          personnel_temporary_notifyStatus: "update"
        };
        
        await this.$http.post(
          "personnel_temporary_notify.update.php",
          notifyData
        );

        if (result.data.status === true) {
          this.showSnackbar('แก้ไขข้อมูลเรียบร้อยแล้ว', 'success');
          await this.personnel_temporary_notifyQueryAll();
          this.editpersonnel_temporarydialog = false;
        } else {
          this.showSnackbar('เกิดข้อผิดพลาดในการแก้ไขข้อมูล', 'error');
        }
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการแก้ไขข้อมูล', 'error');
      } finally {
        this.saving = false;
      }
    },

    async personnel_temporaryUPdate(personnel_temporary_notifyID) {
      const result = await Swal.fire({
        title: 'ยืนยันการดำเนินการ',
        text: 'เปลี่ยนสถานะเป็น "เสร็จสิ้น"',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#4CAF50',
        cancelButtonColor: '#f44336',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      });

      if (result.isConfirmed) {
        try {
          const updateData = {
            ApiKey: this.ApiKey,
            personnel_temporary_notifyStatus: "update",
            personnel_temporary_notifyID: personnel_temporary_notifyID
          };
          
          const response = await this.$http.post(
            "personnel_temporary_notify.update.php",
            updateData
          );
          
          if (response.data.status === true) {
            this.showSnackbar('อัปเดตสถานะเรียบร้อยแล้ว', 'success');
            await this.personnel_temporary_notifyQueryAll();
          } else {
            this.showSnackbar('เกิดข้อผิดพลาดในการอัปเดตสถานะ', 'error');
          }
        } catch (error) {
          this.showSnackbar('เกิดข้อผิดพลาดในการอัปเดตสถานะ', 'error');
        }
      }
    },

    async personnel_temporary_notifyQueryAll() {
      this.loading = true;
      try {
        const result = await this.$http.post("personnel_temporary_notify.php", {
          ApiKey: this.ApiKey
        });
        this.personnel_temporary_notifys = result.data;
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการโหลดข้อมูล', 'error');
      } finally {
        this.loading = false;
      }
    },

    async refreshData() {
      await this.personnel_temporary_notifyQueryAll();
      this.showSnackbar('รีเฟรชข้อมูลเรียบร้อยแล้ว', 'info');
    },

    validateInput() {
      const maxLength = 13;
      const regex = /^[0-9]\d*$/;
      const value = this.editpersonnel_temporary.id_card;
      
      if (!value || value.length !== maxLength || !value.match(regex)) {
        this.validateInputcheck = "false";
        return;
      }

      // Thai ID validation algorithm
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(value.charAt(i)) * (13 - i);
      }
      
      const mod = sum % 11;
      const check = (11 - mod) % 10;
      
      this.validateInputcheck = check === parseInt(value.charAt(12)) ? "true" : "false";
    },

    showSnackbar(text, color = 'success') {
      const iconMap = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information'
      };

      this.snackbar = {
        show: true,
        text,
        color,
        icon: iconMap[color] || 'mdi-information',
        timeout: 5000
      };
    },

    // Status helper methods
    getStatusColor(status) {
      return status === 'send' ? 'orange' : 'green';
    },

    getStatusTextColor(status) {
      return 'white';
    },

    getStatusIcon(status) {
      return status === 'send' ? 'mdi-clock-outline' : 'mdi-check-circle';
    },

    getStatusText(status) {
      return status === 'send' ? 'รอดำเนินการ' : 'เสร็จสิ้น';
    }
  },

  computed: {
    // Computed properties for reactive data
    date_today_log() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear() + 543;
      const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      return `${dd}/${mm}/${yyyy}/${time}`;
    }
  }
};
</script>